// extracted by mini-css-extract-plugin
export default {"PrivacyToggle":"gQ2G_Zwsl_"};